module.exports = __webpack_public_path__ + "img/tshirt_normal.7c671b5d.png";